/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const GridFourOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 4.12v15.76M19.88 12H4.12m.76-7.88h14.24c.42 0 .76.34.76.76v14.24c0 .42-.34.76-.76.76H4.88a.76.76 0 0 1-.76-.76V4.88c0-.42.34-.76.76-.76z"
})));
// Fill
const GridFourFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.12 3.38H4.88c-.4 0-.78.15-1.07.43-.28.29-.43.67-.43 1.07v14.24c0 .4.15.78.43 1.07.29.28.67.43 1.07.43h14.24c.4 0 .78-.15 1.07-.43.28-.29.43-.67.43-1.07V4.88c0-.4-.15-.78-.43-1.07a1.53 1.53 0 0 0-1.07-.43zm0 8.62H12V4.88h7.12V12zM4.88 12H12v7.12H4.88V12z"
})));
// DuoTone
const GridFourDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 12H4.12V4.88c0-.2.08-.39.22-.54a.79.79 0 0 1 .54-.22H12V12z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 4.12v15.76M19.88 12H4.12m.76-7.88h14.24c.42 0 .76.34.76.76v14.24c0 .42-.34.76-.76.76H4.88a.76.76 0 0 1-.76-.76V4.88c0-.42.34-.76.76-.76z"
})));
/**
  Icon GridFourIcon in design group
*/
export const GridFourIcon = createIcon('GridFourIcon', 'grid-four', 'design', GridFourOutline, GridFourFill, GridFourDuotone, "0 0 24 24");